import React from 'react';
import {Container} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import ManagementContainer from './management/ManagementContainer';
import {connect} from 'react-redux';

const TeamManagement = ({emailAdr, toggles}) => {
  return (
    <Main>
      <Container>
        <ManagementContainer emailAdr={emailAdr} toggles={toggles} />
      </Container>
    </Main>
  );
};

const mapStateToProps = (state) => ({
  emailAdr: state.auth.emailAdr,
  toggles: _.get(state.toggles, 'toggles'),
});

export default connect(mapStateToProps, null)(TeamManagement);
